import { MedplumClient } from "@medplum/core";
import { getPatientName } from "../Eligibility/EligibiltyService";
import {
  DocumentfetchForEpic,
  circularPlatformLogo,
  epicHandler,
} from "../../utils";
import { forwardRef } from "react";
import { Group, Text } from "@mantine/core";
import { showNotification } from "@mantine/notifications";

export const fetchPatientList = async (
  medplum: MedplumClient,
  view?: boolean
) => {
  const response = await medplum.searchResources("Patient", "_count=500");
  const patientData = response
    .map((patient: any) => {
      const medplumPatientId = patient?.id;
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding: any) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item: any) => item.system && item.system.includes("athena")
      );
      const systemUrl =
        "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id";

      const patientEpicId = patient?.identifier?.find(
        (item: any) => item.system && item.system.includes(systemUrl)
      )?.value;

      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id:any) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }

      // Filter for EPIC only
      if (ehrtype !== "EPIC") {
        return null;
      }

      const EHRIcon = (
        <img
          src={circularPlatformLogo["epic"]}
          style={{
            marginRight: "10px",
            width: "30px",
          }}
          alt="EPIC"
        />
      );
      if (view === true) {
        return {
          label: getPatientName(patient.name),
          value: medplumPatientId,

          ehr: ehrtype,
          icon: EHRIcon,
        };
      }

      return {
        label: getPatientName(patient.name),
        value: [medplumPatientId, patientEpicId],
        EpicId: patientEpicId,

        ehr: ehrtype,
        icon: EHRIcon,
        medplumId: medplumPatientId,
      };
    })
    .filter((patient) => patient !== null) as {
    label: string;
    value: any;
    EpicId: any;
    ehr: string;

    icon: JSX.Element;
    medplumId: any;
  }[];

  return patientData;
};

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  value: any;
  ehr: string;
  icon: any;
}

export const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
  ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
    <div ref={ref} {...others}>
      <Group
        noWrap
        style={{
          justifyContent: "space-between",
          height: "30px",
          width: "100%",
        }}
      >
        <div>
          <Text>{label}</Text>
        </div>
        <div>{icon}</div>
      </Group>
    </div>
  )
);

export const documentRefrenceForPatient = async (
  patientId: string,
  medplum: MedplumClient,
  pageNumber?: any
) => {
  const count = 20;

  let queryString = `_count=20&_offset=${
    (pageNumber - 1) * count
  }&_sort=-_lastUpdated&_total=accurate&patient=Patient/${patientId}`;
  const response = await medplum.searchResources(
    "DocumentReference",
    queryString
  );
  return response;
};
export const downloadForDocrefrence = async (Docrefid: any, medplum: any) => {
  let blobUrl = "";
  const getDocsPayload = {
    eventType: "document",

    DocrefId: Docrefid,
  };
  const resposnse = await epicHandler(medplum, getDocsPayload).then(
    (response) => {
      const buffer = new Uint8Array(response.body.data);

      // Create a blob from the buffer
      const blob = new Blob([buffer], { type: "text/html" });
      blobUrl = URL.createObjectURL(blob);
      return blobUrl;
    }
  );
  return blobUrl;
};
export const fetchPatientDetails = async (medplum: MedplumClient, id: any) => {
  const systemUrl =
    "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id";
  try {
    const data: any = await medplum.searchResources(
      "Patient",
      `_count=20&_id=${id}`
    );
    const epicId = data?.[0]?.identifier?.find(
      (item: any) => item.system && item.system.includes(systemUrl)
    )?.value;
    return epicId;
  } catch (error) {
    console.error("Error fetching patient details:", error);
    return null;
  }
};
